import axios from 'axios';
import API from '../config/API';

/**
 * Discount codes on the server (docs/DISCOUNT_CODES_BACKEND.md).
 *
 *   list()                       the codes at this location (salon codes, and
 *                                a self-employed stylist's own)
 *   save(code)                   create, or change one that hasn't been used
 *   status(id, status, note)     live | paused | ended, with a reason
 *   validate(body)               public: check a code against a basket
 *   redeem(body) / release(body) a use, held on a booking and let go
 *   choice(body)                 a self-employed stylist's answer on salon codes
 *   choices()                    those answers at this location (owner/team: all; a stylist: their own)
 *   manualRule() / setManualRule(rule)  selling below the menu: 'log' | 'refuse' (owner sets it)
 *
 * Each resolves to responseData and rejects with `notThere` set when the
 * endpoint doesn't exist yet (404, or no CORS answer for an unknown route),
 * which is what tells the store to use the device stand-in on staging.
 */

const headers = () => ({
  'Content-Type': 'application/json',
  authorization: 'Basic YmV1YXBwOmJldWFwcA==',
  accessToken: `${localStorage.getItem('accessToken') || ''}`,
});

const unwrap = (res) => {
  const d = res && res.data;
  if (d && d.statusCode === 1) return d.responseData !== undefined ? d.responseData : d;
  const reason = (d && d.error && (d.error.responseMessage || d.error.message)) || 'That didn’t work just now. Try again.';
  const e = new Error(reason);
  e.plain = true;
  e.reason = d && d.error && d.error.reason;
  throw e;
};

const missing = (err) => {
  if (err && err.plain) throw err;
  const status = err && err.response && err.response.status;
  const e = new Error(status === 404 || !err || !err.response ? 'Not on the server yet' : ((err && err.message) || 'Request failed'));
  e.notThere = status === 404 || !(err && err.response);
  e.status = status;
  throw e;
};

const get = (url, params) => axios.get(url, { headers: headers(), params }).then(unwrap, missing);
const post = (url, body) => axios.post(url, body, { headers: headers() }).then(unwrap, missing);

export const discountService = {
  list: (salonId) => get(API.DISCOUNT_LIST, salonId ? { salonId } : undefined),
  save: (code) => post(API.DISCOUNT_SAVE, code),
  status: (id, status, note) => post(API.DISCOUNT_STATUS, { id, status, note }),
  validate: (body) => post(API.DISCOUNT_VALIDATE, body),
  redeem: (body) => post(API.DISCOUNT_REDEEM, body),
  release: (body) => post(API.DISCOUNT_RELEASE, body),
  choice: (body) => post(API.DISCOUNT_CHOICE, body),
  choices: () => get(API.DISCOUNT_CHOICES),
  manualRule: () => get(API.DISCOUNT_MANUAL_RULE),
  setManualRule: (rule) => post(API.DISCOUNT_MANUAL_RULE, { rule }),
};

export default discountService;
